import { useStaticQuery, graphql } from 'gatsby';

interface IProductQuote {
  buttonKind: string,
  buttonText: string,
  quoteConfirmationMessage: {
    aliase: {
      aliase: string
    },
    quoteConfirmationMessage: {
      quoteConfirmationMessage: string
    }
  },
  customerGroupId: string
}

const useProductQuoteData = (customerGroupId: string) => {
  const { systemPages: { nodes: productQuotes } } = useStaticQuery(graphql`
    query {
      systemPages: allContentfulProductQuote {
        nodes {
          buttonKind
          buttonText
          quoteConfirmationMessage {
            aliase {
              aliase
            }
            quoteConfirmationMessage {
              quoteConfirmationMessage
            }
          }
          customerGroupId
        }
      }
    }`);
  return productQuotes.filter((productQuote: IProductQuote) => productQuote.customerGroupId?.includes(customerGroupId));
};

export default useProductQuoteData;
